// src/features/collaboration/components/EventCard.js
import React from 'react';
import { Card, CardContent, CardMedia, Typography, Box, Button } from '@mui/material';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';

const EventCard = ({ event, compact = false }) => {
  const navigate = useNavigate();
  const dateText = event?.date ? format(new Date(event.date), 'eee, d MMM yyyy @ HH:mm') : 'TBA';

  return (
    <Card elevation={1} sx={{ display: 'flex', mb: 2, cursor: 'pointer' }} onClick={() => navigate(`/events/${event.id}`)}>
      {event.bannerUrl && (
        <CardMedia component="img" image={event.bannerUrl} alt={event.title} sx={{ width: compact ? 140 : 200, objectFit: 'cover' }} />
      )}
      <CardContent sx={{ flex: 1 }}>
        <Typography variant={compact ? 'subtitle1' : 'h6'} fontWeight="600">{event.title}</Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
          {dateText} • {event.location || 'Location TBA'}
        </Typography>
        {!compact && (
          <>
            <Typography variant="body2" sx={{ mt: 1 }}>{event.description}</Typography>
            <Box sx={{ mt: 2 }}>
              <Button size="small" variant="outlined">View details</Button>
            </Box>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default EventCard;
